<script>
import { isNullOrEmptyArray } from '@/helpers/array-helpers'
import Chart from 'chart.js/auto'

export default {
  name: 'DonutChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 120,
    },
    width: {
      type: Number,
      default: 120,
    },
    options: {
      type: Object,
      default: () => {},
    },
    segmentColors: {
      type: Array,
      default: () => [
        '#FF6384', // Red
        '#FFCE56', // Yellow
        '#00ADEF', // Blue
        '#4BC0C0', // Teal
        '#3C3087', // Purple
        '#FF9800', // Orange
        '#3FAC49', // Green
        '#F6B419', // Gold
        '#FF5733', // Coral
        '#8A2BE2', // Blue Violet
      ],
    },
  },
  computed: {
    chartContainerStyle() {
      return {
        position: 'relative',
        height: `${this.height}px`,
        width: `${this.width}px`,
      }
    },
  },
  watch: {
    data(newData, oldData) {
      if (this.chart) {
        this.chart.data.datasets[0].data = newData
        this.chart.update()
      }
    },
    labels(newLabels, oldLabels) {
      if (this.chart) {
        this.chart.data.labels = newLabels
        this.chart.update()
      }
    },
  },
  mounted() {
    this.renderChart()
  },
  destroyed() {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  methods: {
    handleChartSegmentClick(event) {
      /**
       * @type {{datasetIndex: number, index: number}}
       */
      const clickEventPositionDataList = this.chart.getElementsAtEventForMode(
        event,
        'nearest',
        { intersect: true },
        true
      )

      if (isNullOrEmptyArray(clickEventPositionDataList)) return

      const clickEventPositionData = clickEventPositionDataList[0]

      this.$emit('onChartClick', {
        label: this.labels[clickEventPositionData.index],
        data: this.data[clickEventPositionData.index],
        segmentIndex: clickEventPositionData.index,
      })
    },
    renderChart() {
      const options = {
        ...{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: this.title.length > 0,
              text: this.title,
            },
          },
          hover: {
            mode: 'index', // Display labels on hover
          },
          onClick: this.handleChartSegmentClick,
        },
        ...this.options,
      }

      const ctx = this.$refs.donutChart.getContext('2d')
      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.data,
              backgroundColor: this.segmentColors,
              borderWidth: 1,
            },
          ],
        },
        options,
      })
    },
  },
}
</script>

<template>
  <div class="d-flex justify-end align-right w-100">
    <div
      class="chart-container d-flex justify-end"
      :style="chartContainerStyle"
    >
      <canvas ref="donutChart" class="chart"></canvas>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chart {
  cursor: pointer !important;
}
</style>
